<div class="modal-header">
  <h4 class="modal-title">{{ title | translate }}</h4>
  <button type="button" class="close" (click)="closeModal()">{{ 'exports.modalHeader.closeButton' | translate }}</button>
</div>
<div class="modal-body">
  <form #filmForm="ngForm" (ngSubmit)="updateProgAnnonce()">
    <div class="form-group">
      <label for="selectedCinema">{{ 'progAnnonceModal.selectCinema' | translate }}</label>
      <select id="selectedCinema" [formControl]="cinemaControl" class="form-control">
        <option *ngFor="let cinema of cinemas" [value]="cinema.id_cinema">
          {{ cinema.liv_ville }} - {{ cinema.nom_cinema }}
        </option>
      </select>
    </div>
    <label>{{ 'progAnnonceModal.selectDate' | translate }}</label>
    <div class="form-group">
      <div class="date-picker-container">
      <input
        class="form-control datepicker-input"
        [formControl]="dateProgControl"
        ngbDatepicker
        [firstDayOfWeek]="3"
        #startDp="ngbDatepicker"
        name="date"
        required
      />
      <button
        class="btn btn-outline-secondary bi bi-calendar3"
        (click)="startDp.toggle()"
        type="button"
      >
      </button>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary validate-btn" (click)="filmForm.ngSubmit.emit()">{{ 'progAnnonceModal.validateButton' | translate }}</button>
</div>
